module.exports = __webpack_public_path__ + "img/slide25-tronic.4282d65d.png";